import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {QbInvoiceAutoDebitDto} from "../../model/QbInvoiceAutoDebitDto";
import {AuthorizeNetPaymentProfileDto} from "../../model/AuthorizeNetPaymentProfileDto";
import {ngStorage} from "ngstorage";
import StorageService = ngStorage.StorageService;

export default class AutoController implements Ng1Controller {
    private invoices: QbInvoiceAutoDebitDto[] = [];
    private error: any;
    private processing: boolean;

    $onInit(): void {
        this.refresh();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService,
                private $localStorage: StorageService,
                private $state: StateService,
                private $stateParams: any) {
        $dataHub.client.bindAllInvoiceAutoDebit(() => this.invoices);

        $dataHub.onConnected(this.refresh);
    }

    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        this.$dataHub.server.invoiceAutoDebitSub()
            .catch(e => this.error = e);
    };

    customerSetAutoDebitPaymentProfile = (invoices: QbInvoiceAutoDebitDto[], profile: AuthorizeNetPaymentProfileDto) => {
        this.$dataHub.server.customerAutoDebitPaymentProfileUpdate(invoices[0].customer, profile)
            .then(() => invoices.forEach(i => i.autoDebitPaymentProfile = profile));
    };

    autoDebitNow = (row: QbInvoiceAutoDebitDto) => {
        var originalBalance = row.balanceRemaining;
        row.balanceRemaining = 0;
        this.$dataHub.server.invoiceAutoDebit(row)
            .catch(e => {
                row.balanceRemaining = originalBalance;
                window.alert(e);
            });
    };

    autoDebitProcessAll = () => {
        this.processing = true;
        this.$dataHub.server.invoiceAutoDebitProcessAll()
            .finally(() => this.processing = false);
    };

    filter = (row: QbInvoiceAutoDebitDto) => {
        if (row.dueDate > new Date()) {
            return this.showFuture || false;
        }
        return true;
    }

    get showFuture() {
        return this.$localStorage.invoiceAutoDebitsShowFuture || false;
    }

    set showFuture(value: boolean) {
        this.$localStorage.invoiceAutoDebitsShowFuture = value;
    }
}
